<template>
  <div class="q-pa-sm">
    <el-tabs v-model="activeName" @tab-click="handkeClick">
      <el-tab-pane label="时间视图" name="first">
        <gantt-elastic
          v-if="showTasks"
          :options="options"
          :tasks="tasks"
          style="margin-top: 20px"
          class="gante"
        ></gantt-elastic>
      </el-tab-pane>
      <el-tab-pane label="人员视图" name="second">
        <gantt-elastic
          v-if="showTasks1"
          :options="options1"
          :tasks="tasks1"
          style="margin-top: 20px"
          class="gante"
        >
        </gantt-elastic>
      </el-tab-pane>
    </el-tabs>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="detailsFormVsible"
        class="edit-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div>
          <el-form
            label-width="110px"
            :inline="true"
            :model="fromData"
            ref="fromData"
          >
            <el-form-item label="项目名称">
              <el-input disa  bled v-model="fromData.name"></el-input>
            </el-form-item>
            <el-form-item label="项目参与人姓名">
              <el-input disabled v-model="this.fromName"></el-input>
            </el-form-item>
            <el-form-item label="项目开始时间">
              <el-input disabled v-model="fromData.start_time"></el-input>
            </el-form-item>
            <el-form-item label="项目结束时间">
              <el-input disabled v-model="fromData.end_time"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input disabled v-model="fromData.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
import GanttElastic from "gantt-elastic";
import GanttHeader from "gantt-elastic-header";
import dayjs from "dayjs";
import { gettimetask, gettaskbyid, gettimeuser } from "../../api/view";
import { getstatuss } from "../../api/setting";

// just helper to get current dates
function getDate(hours) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();
  const timeStamp = new Date(
    currentYear,
    currentMonth,
    currentDay,
    0,
    0,
    0
  ).getTime();
  return new Date(timeStamp + hours * 60 * 60 * 1000).getTime();
}
let that;
let tasks = [
  {
    id: 1,
    label: "Make some noise",
    start: getDate(-24 * 5),
    duration: 4 * 24 * 60 * 60 * 1000,
    percent: 85,
    type: "milestone",
    collapsed: true,
  },
  // {
  //   id: 2,
  //   label: "With great power comes great responsibility",
  //   start: getDate(-24 * 4),
  //   duration: 4 * 24 * 60 * 60 * 1000,
  //   percent: 50,
  //   type: "milestone",
  //   collapsed: true,
  //   style: {
  //     base: {
  //       fill: "#1EBC61",
  //       stroke: "#0EAC51",
  //     },
  //   },
  // },
];
let tasks1 = [
  {
    id: 1,
    label: "Make some noise",
    start: getDate(-24 * 5),
    duration: 4 * 24 * 60 * 60 * 1000,
    percent: 85,
    type: "milestone",
    collapsed: true,
  },
];
let options = {
  locale: {
    weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    months: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ],
  },
  taskMapping: {
    progress: "percent",
  },
  maxRows: 100,
  // maxHeight: 660,
  title: {
    label: "Your project title as html (link or whatever...)",
    html: false,
  },
  row: {
    height: 25,
  },
  calendar: {
    hour: {
      // 小时
      display: false,
    },
  },
  chart: {
    progress: {
      // 增加重影
      bar: false,
    },
    expander: {
      display: false,
    },
  },
  taskList: {
    expander: {
      straight: false,
    },
    columns: [
      {
        id: 1,
        label: "项目",
        value: "project_name",
        align: "center",
        width: 150,
        expander: true,
        html: true,
        // events: {
        //   click({ data, column }) {
        //     that.handleEdit(data.id)
        //   }
        // }
      },
      {
        id: 2,
        label: "任务(点击可查看详情)",
        value: "label",
        align: "center",
        width: 140,
        html: true,
        cursor: "pointer",
        events: {
          click({ data, column }) {
            that.handleEdit(data.test_id);
          },
        },
      },
      {
        id: 3,
        label: "状态",
        value: "Status",
        align: "center",
        html: true,
        width: 140,
      },
      {
        id: 4,
        label: "开始",
        value: (task) => dayjs(task.start).format("YYYY-MM-DD"),
        width: 120,
      },
      {
        id: 5,
        label: "结束",
        value: (task) => dayjs(task.end).format("YYYY-MM-DD"),
        width: 120,
      },
    ],
  },
};
let options1 = {
  locale: {
    weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    months: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ],
  },
  taskMapping: {
    progress: "percent",
  },
  maxRows: 100,
  // maxHeight: 650,
  title: {
    label: "Your project title as html (link or whatever...)",
    html: false,
  },
  row: {
    height: 25,
  },
  calendar: {
    hour: {
      // 小时
      display: false,
    },
  },
  chart: {
    progress: {
      bar: false,
    },
    expander: {
      display: false,
    },
  },
  taskList: {
    expander: {
      straight: false,
    },
    columns: [
      {
        id: 1,
        label: "人员",
        value: "user_name",
        align: "center",
        width: 150,
        expander: true,
        html: true,
        // events: {
        //   click({ data, column }) {
        //     that.handleEdit(data.id)
        //   }
        // }
      },
      {
        id: 2,
        label: "任务",
        value: "label",
        align: "center",
        width: 100,
        html: false,
      },
      {
        id: 3,
        label: "状态",
        value: "Status",
        align: "center",
        html: true,
        width: 120,
      },
      {
        id: 4,
        label: "开始",
        value: (task) => dayjs(task.start).format("YYYY-MM-DD"),
        width: 120,
      },
      {
        id: 5,
        label: "结束",
        value: (task) => dayjs(task.end).format("YYYY-MM-DD"),
        width: 120,
      },
    ],
  },
};
// //进行中
// let doingStyle = {
//   base: {
//     fill: "",
//     stroke: "",
//   },
// };
// //阻塞
// let warnStyle = {
//   base: {
//     fill: "",
//     stroke: "",
//   },
// };
// //已完成
// let finishStyle = {
//   base: {
//     fill: "",
//     stroke: "",
//   },
// };
//未开始
// let cancelStyle = {
//   base: {
//     fill: "",
//     stroke: "",
//   },
// };

export default {
  data() {
    return {
      activeName: "first",
      //弹框
      detailsFormVsible: false,
      //弹框数据
      fromData: [],
      //弹框数据——项目参与人
      fromName: [],
      //状态颜色
      allstatu: [],
      // doingStyle,
      // finishStyle,
      // warnStyle,
      // cancelStyle,
      tasks,
      tasks1,
      options1,
      options,
      showTasks: false,
      showTasks1: false,
      title: "详情",
    };
  },
  components: {
    GanttElastic,
    GanttHeader,
  },
  //
  methods: {
    handleEdit(id) {
      let params = {
        token: localStorage.getItem("token"),
        id: id,
      };
      gettaskbyid(params).then((res) => {
        if (res.errno === 0) {
          this.title = "详情";
          this.detailsFormVsible = true;
          this.fromData = res.data;
          this.fromName = [];
          if (res.data.taskuser != "") {
            for (let i in res.data.taskuser) {
              this.fromName.push(res.data.taskuser[i].user_name);
            }
            this.fromName = this.fromName.join(",");
          }
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    getData() {
      let params = {
        token: localStorage.getItem("token"),
      };
      gettimetask(params).then((res) => {
        if (res.errno === 0) {
          var temp1 = res.data;
          this.tasks = [];
          var sum = 0;
          for (var j in temp1) {
            var temp = temp1[j].task;
            // if (temp != "") {
            for (var i in temp) {
              temp[i].start_time = new Date(
                temp[i].start_time.replace(/-/g, "/")
              );
              temp[i].end_time = new Date(temp[i].end_time.replace(/-/g, "/"));
              sum += 1;
              var obj = {
                // project_name: temp1[j].project_name,
                id: sum,
                test_id: temp[i].id,
                label:
                  '<span style="cursor: pointer;">' + temp[i].name + "</span>",
                user: temp[i].user_ids,
                start: new Date(temp[i].start_time).getTime(),
                end: new Date(temp[i].end_time).getTime(),
                // Status: '<span style="cursor: pointer;">'+temp[i].name+'</span>',
                duration:
                  new Date(temp[i].end_time).getTime() -
                  new Date(temp[i].start_time),
                type: "milestone",
                percent: 100,
              };
              if (i == 0) {
                obj.project_name =
                  temp1[j].project_name +
                  '<span style="color:red">' +
                  "(" +
                  temp.length +
                  ")" +
                  "</span>";
              }
              for (var m in this.allstatu) {
                let lcsd = {
                  base: {
                    fill: "",
                    stroke: "",
                  },
                };
                if (temp[i].status == this.allstatu[m].id) {
                  lcsd.base.fill = this.allstatu[m].color;
                  lcsd.base.stroke = this.allstatu[m].color;
                  obj.style = lcsd;
                  // obj.Status='<div class="finished1" v-if='+this.allstatu[m].id==1+'>'+this.allstatu[m].id+"</div>";
                  // obj.Status='<span class="'+temp[i].status==1?'jingxing1':temp[i].status==1?'jingxing1':temp[i].status==1?'jingxing1':'jingxing1'+' style="background-color:'+this.allstatu[m].color+'">'+this.allstatu[m].name +"</span>";
                  if (this.allstatu[m].id==1) {
                    obj.Status ='<span class="begin1" style="background-color:' +this.allstatu[m].color +'">' +this.allstatu[m].name +"</span>";
                  }else if(this.allstatu[m].id==2){
                    obj.Status ='<span class="jingxing1">' +this.allstatu[m].name +"</span>";

                  }else if(this.allstatu[m].id==3){
                     obj.Status ='<span class="finished1">' +this.allstatu[m].name +"</span>";
                  }else{
                    obj.Status ='<span class="rest" style="background-color:' +this.allstatu[m].color +'">' +this.allstatu[m].name +"</span>";
                  }
                  this.tasks.push(obj);
                }
              }
            }
            // }
            if (this.tasks.length > 0) {
              this.showTasks = true;
            }
          }
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    getData1() {
      let params = {
        token: localStorage.getItem("token"),
      };
      gettimeuser(params).then((res) => {
        if (res.errno === 0) {
          var temp1 = res.data;
          this.tasks1 = [];
          var sum1 = 0;
          for (var j in temp1) {
            var temp = temp1[j];
            if (temp != "") {
              for (var i in temp) {
                temp[i].start_time = new Date(
                  temp[i].start_time.replace(/-/g, "/")
                );
                temp[i].end_time = new Date(
                  temp[i].end_time.replace(/-/g, "/")
                );
                sum1 += 1;
                var obj = {
                  // project_name: temp1[j].project_name,
                  id: sum1,
                  label: temp[i].name,
                  // user_name: temp[i].user_name,
                  start: new Date(temp[i].start_time).getTime(),
                  end: new Date(temp[i].end_time).getTime(),
                  // Status: temp[i].status,
                  duration:
                    new Date(temp[i].end_time).getTime() -
                    new Date(temp[i].start_time),
                  type: "milestone",
                  percent: 100,
                };

                if (i == 0) {
                  obj.user_name =
                    temp[i].user_name +
                    '<span style="color:red">' +
                    "(" +
                    temp.length +
                    ")" +
                    "</span>";
                }
                for (var m in this.allstatu) {
                  let lcsd = {
                    base: {
                      fill: "",
                      stroke: "",
                    },
                  };
                  if (temp[i].status == this.allstatu[m].id) {
                    lcsd.base.fill = this.allstatu[m].color;
                    lcsd.base.stroke = this.allstatu[m].color;
                    obj.style = lcsd;
                   if (this.allstatu[m].id==1) {
                    obj.Status ='<span class="begin1" style="background-color:' +this.allstatu[m].color +'">' +this.allstatu[m].name +"</span>";
                  }else if(this.allstatu[m].id==2){
                    obj.Status ='<span class="jingxing1">' +this.allstatu[m].name +"</span>";

                  }else if(this.allstatu[m].id==3){
                     obj.Status ='<span class="finished1">' +this.allstatu[m].name +"</span>";
                  }else{
                    obj.Status ='<span class="rest" style="background-color:' +this.allstatu[m].color +'">' +this.allstatu[m].name +"</span>";
                  }
                    this.tasks1.push(obj);
                  }
                }
              }
            }
            if (this.tasks1.length > 0) {
              this.showTasks1 = true;
            }
          }
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //状态颜色
    getstatu() {
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage3,
      };
      getstatuss(params).then((res) => {
        if (res.errno === 0) {
          this.allstatu = res.data.data;
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.errno);
        }
      });
    },
    handkeClick(tab, event) {
      // console.log(tab, event);
    },
  },
  mounted() {
    this.getstatu();
    this.getData();
    this.getData1();
    that = this;
  },
  created() {
    this.getstatu();
    this.getData();

    this.getData1();
  },
};
</script>
<style  scoped>
/* .q-pa-sm >>> .in {
  margin: 10px 0;
}
.q-pa-sm{
  padding: 10px;
}
.q-pa-sm >>> .in_2 {
  margin: 15px 0;
} */
.edit-dialog >>> .el-dialog {
  width: 25%;
}
.edit-dialog >>> .el-input__inner {
  width: 100%;
  height: 32px;
  border: 1px solid #cccccc;
}
.navigation span {
  cursor: pointer;
}

/* 导航栏 */
.q-pa-sm {
  background-color: #fbfbfb;
}

.q-pa-sm >>> .el-tabs__header {
  padding-left: 30px;
  background-color: #ffffff;
}

.q-pa-sm >>> .el-tabs__nav-wrap::after {
  content: "";
  background-color: revert;
}

.q-pa-sm >>> .el-tabs__nav {
  height: 60px;
}
.q-pa-sm >>> .el-tabs__item.is-active {
  color: #141464;
  font-size: 17px;
  font-weight: 700;
}

.q-pa-sm >>> .el-tabs__item.is-active {
  color: #141464;
}

.q-pa-sm >>> .el-tabs__item {
  color: #666666;
}

.q-pa-sm >>> .el-tabs__active-bar {
  background-color: #2b52e9;
}

.q-pa-sm >>> .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 0;
  height: 60px;
  line-height: 60px;
}

.q-pa-sm >>> .el-tabs__item {
  font-size: 16px;
}

/*间距*/
.q-pa-sm >>> .el-row {
  margin-top: 25px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
/* 导航栏 */
/* 居中 */
.gante >>> .gantt-elastic__task-list-item-value-container {
  margin: auto !important;
  text-align: center !important;
}
.gante >>>.gantt-elastic__task-list-item-value{
  line-height: 2em !important;
}
.gante >>> .gantt-elastic__task-list-header-column {
  text-align: center;
  background-color: #f5f5f5 !important ;
}
.gante >>>.gantt-elastic__calendar{
  background-color: #f5f5f5 !important;
}
/* 进行中 */
  .gante >>>  .jingxing1 {
    display: block;
    width: 65px;
    line-height: 25px;
    height: 25px;
    margin: 0 auto;
    color: #41bfd6;
    background-color: #ebf9fc;
    border-radius: 15px;
  }

  /*未开始 */
  .gante >>>  .begin1 {
    display: block;
    width: 62px;
    line-height: 25px;
    height: 25px;
    margin: 0 auto;
    color: #7747df;
    background-color: #f2edfc;
    border-radius: 15px;
  }


  /* 已完成 */
  .gante >>> .finished1 {
    display: block;
    width: 65px;
    line-height: 25px;
    height: 25px;
    margin: 0 auto;
    color: #5ec16c;
    background-color: #e8faeb;
    border-radius: 15px;
  }
/* 其余状态颜色 */
.gante >>> .rest {
  display: block;
  width: 70px;
  height: 25px;
  margin: 0 auto;
  /* color: #5ec16c;
  background-color: #e8faeb; */
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/work/index.vue